import { ProductIndexItemInterface } from "../../../common/interfaces/apiV2/shared/ProductIndexItemInterface";
import { selectProduct } from "../ProductRangeSlice";
import { useAppDispatch } from "../../../app/hooks";
import { Link } from "react-router-dom";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { JSX } from "react";

interface Props {
    product: ProductIndexItemInterface;
}

export const ProductSelectedItem = (props: Props): JSX.Element => {
    const dispatch = useAppDispatch();

    const { product } = props;

    return (
        <div className="c-products-selected__item">
            <div className="c-products-selected__item__left">
                <div
                    className="cross"
                    onClick={() => dispatch(selectProduct(product))}
                >
                    <img src="/images/cross.svg" alt="cross" />
                </div>
                <Link to={RouteEnum.PRODUCT_RANGE + `/${product.id}`}>
                    <span>{product.label}</span>
                </Link>
            </div>
            {!!product.identifier && (
                <div className="c-products-selected__item__center c-products-selected__item__center--left">
                    <span>{product.identifier}</span>
                </div>
            )}
            <div className="c-products-selected__item__center c-products-selected__item__center--right">
                {product.connection && <span>{product.connection}</span>}
            </div>
            {product.prices && (
                <div className="c-products-selected__item__right">
                    <span>{product.prices.value}</span>
                </div>
            )}
        </div>
    );
};
